import { Flow_0_0_2 } from '@flexus/core';

export const BET_53: Flow_0_0_2 = {
	id: '53',
	name: 'awaiting_maven_request',
	itemType: 'flow',
	header: {
		title: '',
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: '--'
		},
		viewRoles: {
			0: 'Wait for Maven request'
		}
	},
	startNode: '',
	nodes: {}
};
